/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DmvsGadDocsCheckDmvsPendingPozadavkyCreateRequest = {} | null | undefined;
export type DmvsGadDocsCheckDmvsPendingPozadavkyCreateResponse = any;

export type DmvsGadDocsCheckDmvsPendingPozadavkyCreateQuery = {};

/**
 * POST /dmx-server/dmvs_gad_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - dmvs_gad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsGadDocsCheckDmvsPendingPozadavkyCreateOperation = (
  rest?: DmvsGadDocsCheckDmvsPendingPozadavkyCreateQuery | null,
) =>
  ({
    method: 'POST',
    path: `/dmx-server/dmvs_gad_docs/check_dmvs_pending_pozadavky/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dmvs_gad_docs/check_dmvs_pending_pozadavky/' };
  };

/**
 * POST /dmx-server/dmvs_gad_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - dmvs_gad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsGadDocsCheckDmvsPendingPozadavkyCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DmvsGadDocsCheckDmvsPendingPozadavkyCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dmvsGadDocsCheckDmvsPendingPozadavkyCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
